import { fromJS } from 'immutable';
import * as actions from '../../actions/maintenance/role';
import { fetchingState } from '../../constants';

const initialStats = {
  modules: {},
  roles: {},
  rights: {},
  roleRights: {},
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    // Role actions

    case actions.MODULES_FETCH_START:
      return state.setIn(['modules', 'state'], fetchingState.FETCHING);
    case actions.MODULES_FETCH_SUCCESS:
      let newState = state.setIn(['modules', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['modules', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.MODULES_FETCH_ERROR:
      return state.setIn(['modules', 'state'], fetchingState.ERROR);

    case actions.ROLES_FETCH_START:
      return state.setIn(['roles', 'state'], fetchingState.FETCHING);
    case actions.ROLES_FETCH_SUCCESS:
      newState = state.setIn(['roles', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['roles', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.ROLES_FETCH_ERROR:
      return state.setIn(['roles', 'state'], fetchingState.ERROR);

    case actions.ROLE_CREATE_SUCCESS:
      return state.setIn(['roles', 'data'], fromJS(action.data.results));

    case actions.ROLE_DELETE_SUCCESS:
      let newRoles = state.getIn(['roles', 'data']).toJS();
      newRoles = newRoles.filter((role) => role.roleID !== action.roleId);
      return state.setIn(['roles', 'data'], fromJS(newRoles));

    case actions.ROLE_UPDATE_SUCCESS:
      newRoles = state.getIn(['roles', 'data']).toJS();
      newRoles = newRoles.map((role) =>
        role.roleID === action.roleId ? action.data.results[0] : role,
      );
      return state.setIn(['roles', 'data'], fromJS(newRoles));

    case actions.RIGHTS_FETCH_START:
      return state.setIn(['rights', 'state'], fetchingState.FETCHING);
    case actions.RIGHTS_FETCH_SUCCESS:
      newState = state.setIn(['rights', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['rights', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.RIGHTS_FETCH_ERROR:
      return state.setIn(['rights', 'state'], fetchingState.ERROR);

    case actions.ROLE_RIGHTS_FETCH_START:
      return state.setIn(['roleRights', 'state'], fetchingState.FETCHING);
    case actions.ROLE_RIGHTS_FETCH_SUCCESS:
      newState = state.setIn(['roleRights', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['roleRights', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.ROLE_RIGHTS_FETCH_ERROR:
      return state.setIn(['roleRights', 'state'], fetchingState.ERROR);

    case actions.RIGHT_ASSIGN_SUCCESS:
      return state.setIn(['roleRights', 'data'], fromJS(action.data.results));

    case actions.RIGHT_UNASSIGN_SUCCESS:
      let newRights = state.getIn(['roleRights', 'data']).toJS();
      newRights = newRights.filter(
        (right) => right.userRightiD !== action.rightId,
      );
      return state.setIn(['roleRights', 'data'], fromJS(newRights));

    case actions.ALL_RIGHTS_UNASSIGN_SUCCESS:
      return state.setIn(['roleRights', 'data'], fromJS([]));
    default:
      return state;
  }
};
